import type {
    RequestCommerceCustomerVerificationCodeRequest,
    RequestCommerceCustomerVerificationCodeResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const requestCommerceCustomerVerificationCodeOperation = defineCommerceOperation<
    RequestCommerceCustomerVerificationCodeRequest,
    RequestCommerceCustomerVerificationCodeResponse
>("commerce.customer.verification-code.request");
